// extracted by mini-css-extract-plugin
export default {"logoWrapper":"Login_logoWrapper__ATYcs","logo":"Login_logo__j1HlC"};